'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const base = "_9bFNA";
const element = {
	article: "RQf-8",
	aside: "RQf-8",
	details: "RQf-8",
	figcaption: "RQf-8",
	figure: "RQf-8",
	footer: "RQf-8",
	header: "RQf-8",
	hgroup: "RQf-8",
	menu: "RQf-8",
	nav: "RQf-8",
	section: "RQf-8",
	ul: "FDkGp",
	ol: "FDkGp",
	table: "gfAAD",
	select: [
		"RQf-8",
		"xCE08",
		"W6XjV"
	],
	button: "_-9f7I",
	p: "Z1q0y",
	input: [
		"RQf-8",
		"xCE08",
		"wLo5m"
	]
};

exports.base = base;
exports.element = element;
